<template>
  <button @click="open" class="btn btn-info mr-1">
    <i class="fa fa-download"></i>
    {{ $t('title') }}
    <b-modal v-model="showForm" no-close-on-backdrop no-enforce-focus :title="$t('title')">
      <div v-if="!itemCount" class="alert alert-info">
        Hệ thống sẽ tự động xuất dữ liệu liệu trong đêm nay và gửi file vào email bạn cung cấp. Hãy kiểm tra email vào sáng mai nhé!
      </div>
      <div v-else class="alert alert-warning">
        Bạn đang có {{itemCount}} yêu cầu đang chờ xử lý. Nếu bạn tạo yêu cầu mới hệ thống sẽ huỷ bỏ các yêu cầu trước đó.
      </div>
      <form-input :label="$t('fileName')" :model="formModel" attribute="name" :errors="formErrors"></form-input>
      <form-input :label="$t('toEmail')" :model="formModel" attribute="email" :errors="formErrors"></form-input>
      <template v-slot:modal-footer>
        <button class="btn btn-secondary float-right" @click="showForm = false">{{ $t('cancel') }}</button>
        <button class="btn btn-primary" @click="createExport()">
          {{ $t('createRequest') }}
        </button>
      </template>
    </b-modal>
  </button>
</template>
<script>
import CRUD from "@/mixins/CRUD";
import List from "@/mixins/List";

export default {
  mixins: [CRUD, List],
  props: ['filter','type', 'defaultFileName'],
  data() {
    return {
      showForm: false,
      service: '/admin-export',
      autoLoad: false,
      defaultFormModel: {
        name: this.defaultFileName,
        email: this.$store.state.user.email,
        type: this.type,
        filter: this.filter
      },
      defaultFilterFormModel: {
        status: '1',
        type: this.type,
        createdBy: this.$store.state.user._id
      },
      clientA: null,
      clientALoading: false,
      formErrors: []
    }
  },
  methods: {
    open() {
      this.create();
      this.load();
    },
    createExport() {
      this.$swal({
        title: this.$t('createConfirm'),
        icon: this.itemCount ? "warning" : 'question',
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          this.formModel.filter = this.filter;
          this.save();
        }
      })
    },
  },
  i18n: {
    messages: {
      en: {
        title: "Export",
        fileName: "File name",
        toEmail: "Send to email",
        createRequest: "Create request",
        createConfirm: "Are you sure to create a new request?",
      },
      vi: {
        title: "Xuất dữ liệu",
        fileName: "Tên file",
        toEmail: "Gửi tới email",
        createRequest: "Tạo yêu cầu",
        createConfirm: "Bạn có chắc chắn muốn tạo yêu cầu mới?",
      }
    }
  }
}
</script>